<p-autocomplete
  [loading]="SuggestLoading"
  [minLength]="minimumTextLength"
  [suggestions]="SuggestMatchResults"
  field="displayValue"
  [showClear]="true"
  (onClear)="onInputCleared()"
  (onSelect)="onAddressSelected($event)"
  (completeMethod)="onInputChanged($event)"
  #autocomplete
/>
